export enum LOCAL_STORAGE_KEYS {
  AUTH_DATA = '@UNC_DASHBOARD/AUTH_DATA',
  SELECTED_DASHBOARD_SCREEN = '@UNC_DASHBOARD/SELECTED_DASHBOARD_SCREEN',
  SELECTED_DASHBOARD = '@UNC_DASHBOARD/SELECTED_DASHBOARD',
  CUSTOMER_REGISTRY = '@UNC_DASHBOARD/CUSTOMER_REGISTRY',
}
